__webpack_require__.p = "/malaria-inference-frontend/";